import {AdvanceTermFilter, OperatorFilter, TermFilter} from '@dofleini/query-builder';
import {useUser} from '@dofleini/security';
import {proposalrequest} from '@mep/pae-commons';
import {useQuery} from 'react-query';

import ProposalRequestApiService from '@/modules/proposalRequest/services/ProposalRequestApiService';

const {PROPOSAL_STATUS} = proposalrequest;

export const useProposalsByPartner = (proposalId, idNumber, config = {}) => {
  const {isAuthenticated} = useUser();
  const {
    data,
    isLoading
  } = useQuery(['PARTNER', proposalId, idNumber], () => ProposalRequestApiService.searchReduced(
    {
      filters: new OperatorFilter({
        type: 'AND',
        filters: [
          new TermFilter({field: 'partners.idNumber', value: idNumber}),
          new AdvanceTermFilter({type: 'NE', field: '_id', value: proposalId, objectId: true}),
          new AdvanceTermFilter({
            type: 'NIN',
            field: 'status',
            value: [PROPOSAL_STATUS.DISSOLVED, PROPOSAL_STATUS.REJECTED, PROPOSAL_STATUS.DISMISS, PROPOSAL_STATUS.CANCELED]
          }),
        ]
      }).toQuery()
    }
  ), {
    refetchOnWindowFocus: true,
    enabled: !!isAuthenticated && (!!proposalId && !!idNumber),
    ...config
  });

  return {
    proposals: data?.data || [],
    exist: !isLoading && (data?.data || []).length,
    isLoading
  };
};
